import { Component, Inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';
import { MixPanelService } from '../../../services/mix-panel/mix-panel.service';
import { UsageLimitService } from '../../../services/usage-limit/usage-limit.service';
import { resolvePlanUpgradeUrl } from '../../../utils/hub-redirect';
import { DialogBlockInstance } from './dialog-block-instance.enum';

export interface DialogBlockData {
    instance: DialogBlockInstance;
    limite?: number;
    saldo?: number;
    showExtrato?: boolean;
}

@Component({
    selector: 'app-dialog-block',
    standalone: true,
    imports: [MatButton, TranslocoPipe],
    templateUrl: './dialog-block.component.html',
    styleUrl: './dialog-block.component.scss',
})
export class DialogBlockComponent implements OnInit {
    public readonly DialogBlockInstance = DialogBlockInstance;

    public instance = DialogBlockInstance.UPGRADE;
    public limite = 0;
    public saldo = 0;
    public showExtrato = false;

    public readonly limitArtSrc = 'assets/img/dialog-block/dialog-block-limit-gauge.png';
    public readonly upgradeArtSrc = 'assets/img/dialog-block/dialog-block-upgrade-scouter-lift.png';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogBlockData,
        private dialogRef: MatDialogRef<DialogBlockComponent>,
        private mixPanelService: MixPanelService,
        private usageLimitService: UsageLimitService,
    ) {}

    public ngOnInit(): void {
        this.instance = this.data?.instance ?? DialogBlockInstance.UPGRADE;
        this.limite = this.data?.limite ?? 0;
        this.saldo = this.data?.saldo ?? 0;
        this.showExtrato = this.data?.showExtrato ?? false;
    }

    public cancelar(): void {
        this.dialogRef.close(false);
    }

    public upgrade(): void {
        this.mixPanelService.track('click', { page: 'suporte', place: 'modal_limite' });
        this.dialogRef.close(true);
        const subscriptionId = this.usageLimitService.getLastNewMeOverview()?.officialPlan?.subscriptionId;
        window.open(resolvePlanUpgradeUrl(subscriptionId), '_blank');
    }
}
